import React, { useState, useEffect, useRef } from 'react';
import { Button, Loader } from '@thd-olt-component-react/core-ui';
import { bool, func } from 'prop-types';
import styles from './share-toggle.module.scss';

export const ShareToggle = ({ isShared, onShareToggle, isAutoSaving }) => {
  const [isSaved, setIsSaved] = useState(false);
  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    if (!isAutoSaving) {
      setIsSaved(true);
      setTimeout(() => { setIsSaved(false); }, 1000);
    }
  }, [isAutoSaving]);

  return (
    <div className={styles['share-toggle__container']}>
      {isShared
        ? (
          <>
            <div data-testid="share--disabled">Share</div>
            <div className={styles['share-toggle__button-container--right']}>
              <Button data-testid="stop-sharing--enabled" link onClick={onShareToggle}>Stop Sharing</Button>
            </div>
          </>
        )
        : (
          <>
            <div className={styles['share-toggle__button-container--left']}>
              <Button data-testid="share--enabled" link onClick={onShareToggle}>Share</Button>
            </div>
            <div data-testid="stop-sharing--disabled">Stop Sharing</div>
          </>
        )}
      {
        (isAutoSaving || isSaved) && (
          <div className={styles['share-toggle__autosave-wrapper']}>
            {
              isAutoSaving ? (
                <>
                  <Loader active small />
                  <span className={styles['share-toggle__autosave-label']}>Auto Saving</span>
                </>
              ) : (
                <span className={styles['share-toggle__autosave-saved']}>Saved!</span>
              )
            }
          </div>
        )
      }
    </div>
  );
};

ShareToggle.propTypes = {
  isShared: bool,
  onShareToggle: func,
  isAutoSaving: bool,
};

ShareToggle.defaultProps = {
  isShared: true,
  onShareToggle: () => {},
  isAutoSaving: false
};
